import styled from 'styled-components';

export const Container = styled.div`
  .comment {
    background: ${(props) => props.theme.$bg_gray};
    border-radius: 5px;

    &-info {
      margin-top: -3px;
    }

    &-delete {
      font-size: 0.9em;
      color: ${(props) => props.theme.$danger};
    }

    &-name {
      font-size: 0.95em;
      font-weight: bold;

      &-me {
        color: ${(props) => props.theme.$primary_green};
      }

      &-other {
        color: ${(props) => props.theme.$dark};
      }
    }

    &-date {
      font-size: 0.9em;
    }
  }
  .delete-link {
    position: relative;
    display: inline-block;
  }
`;
